import { FavouriteDataAdapter } from '../common/favourite-data-adapter';
import { FavouriteDataOptions } from '../common/favourite-data-options';
import { DrillDownHandler } from '../common/drill-down-builder';
import { StackingOptions } from 'app/components/favourite-layout/constants';
import { MIN_NO_OF_CRITERIAS } from 'app/area/reports/containers/chart/components/attributes/constants';
import { 
  LineAndColumnChartDataOptionsBuilder
} from 'app/components/favourite-layout/favourite/chart-data-options/line-and-column-chart-data-options-builder';

export class AreaChartDataOptionsBuilder extends LineAndColumnChartDataOptionsBuilder {
  constructor(dataOptions: FavouriteDataOptions, dataAdapter: FavouriteDataAdapter, drillDownHandler: DrillDownHandler) {
    super(dataOptions, dataAdapter, drillDownHandler);
    this.chartDataOptionsBuilder.getAxisMin = (c, d) => this.getAxisMin(c, d);
    this.chartDataOptionsBuilder.getAxisMax = (c, d) => this.getAxisMax(c, d);
  }

  private getStackingOptionValue() {
    const { area: { stacking } = { stacking: undefined } } = this.chartDataOptions.plotOptions;
    return stacking;
  }

  private getAxisMin(colIndex: number, dataAdapter: FavouriteDataAdapter): number {
    const stackingOption = this.getStackingOptionValue();
    if (stackingOption === StackingOptions.PERCENT) {
      return 0; //Min value for percent stacked chart is 0%
    }

    return dataAdapter.columnExtremes[colIndex].min;
  }

  private getMaximumValueForStackedColumn(colIndex: number, dataAdapter: FavouriteDataAdapter): number {
    //Because of stacking.
    let max = 0;

    for (const category of dataAdapter.columnCategories[0]) {
      let categorySum = 0;

      for (const row of dataAdapter.dataModel.rows) {
        if (row[0].value === category.value) {
          categorySum += row[colIndex].value;
        }
      }

      if (max < categorySum) {
        max = categorySum;
      }
    }
    return max;
  }

  private getAxisMax(colIndex: number, dataAdapter: FavouriteDataAdapter): number {
    const stackingOption = this.getStackingOptionValue();

    if (stackingOption === StackingOptions.PERCENT) {
      return 100; //Max value for percent stacked chart is 100%
    } else if (stackingOption === StackingOptions.NORMAL) {
      return this.getMaximumValueForStackedColumn(colIndex, dataAdapter);
    }

    return dataAdapter.columnExtremes[colIndex].max;
  }

  protected setStackingOptions(options: Highcharts.Options) {
    options.plotOptions.area = options.plotOptions.area || {};
    const isPercentEnabled = this.chartDataOptionsBuilder.isPercentEnabledForBarColumnAreaChart();
    const isStackedEnabled = this.chartDataOptionsBuilder.isStackedEnabledForBarColumnAreaChart();
    const isMinNoOfCriterias = this.dataAdapter.selectionCount >= MIN_NO_OF_CRITERIAS;

    if (isStackedEnabled && isMinNoOfCriterias) {
      this.dataAdapter.showPercentageInTooltip = true;
    }

    // Set stacking in plotOptions base on chart layout attribute
    if (isStackedEnabled && isPercentEnabled) {
      options.plotOptions.area.stacking = StackingOptions.PERCENT;
    } else if (isStackedEnabled) {
      options.plotOptions.area.stacking = StackingOptions.NORMAL;
    } else {
      options.plotOptions.area.stacking = undefined;
    }
  }
}
